<template>
    <div v-if="user" class="md-layout md-gutter">
      <div class="md-layout-item md-size-100 md-small-size-100 mt-4">
        <div class="md-layout-item md-size-100">
          <add-profile-card :user="user" :apiValidationErrors="apiValidationErrors"/>
        </div>
        <div class="md-layout-item md-size-100">
          <user-password-card :user="user" :apiValidationErrors="apiValidationErrors"/>
        </div>
        <md-card-actions>
          <md-button @click="submitUser" >
            Save
          </md-button>
        </md-card-actions>
      </div>
    </div>
  </template>
  
  <script>
    import AddProfileCard from "@/pages/Dashboard/Users/UserProfile/AddProfileCard.vue";
    import UserPasswordCard from "@/pages/Dashboard/Users/UserProfile/AddPasswordCard.vue";
    import formMixin from "@/mixins/form-mixin";
    import router from "./../../../../router";
  
    export default {
      name: "add-user",
  
      components: {
        "add-profile-card": AddProfileCard,
        "user-password-card": UserPasswordCard
      },
  
      data: () => ({
        user: {name:"",phone:"",email:"",password:"",password_confirmation:""}
      }),

      created(){
        console.log(this.$route.params);
      },

      mixins: [formMixin],

      methods: {
        async submitUser() {
          const user = {
            nombre: this.user.name,
            telefono: this.user.phone,
            email: this.user.email,
            password: this.user.password,
            password_confirmation: this.user.password_confirmation
          }
  
          try {
            await this.$store.dispatch("users/addAsAdmin", user)
            await this.$store.dispatch("alerts/success", "New user created successfully.")
            this.$router.push('/users')
          } catch (e) {
            await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
            this.setApiValidation(e.response.data.errors)
          }
  
        }
      }
  
    }
  </script>